/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Hiddenfrommentees2Inputs */

const en__field_hiddenfrommentees2 = /** @type {(inputs: _Field_Hiddenfrommentees2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden from Mentees`)
};

const de__field_hiddenfrommentees2 = /** @type {(inputs: _Field_Hiddenfrommentees2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor Mentees verborgen`)
};

/**
* | output |
* | --- |
* | "Hidden from Mentees" |
*
* @param {_Field_Hiddenfrommentees2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_hiddenfrommentees2 = /** @type {((inputs?: _Field_Hiddenfrommentees2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Hiddenfrommentees2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_hiddenfrommentees2(inputs)
	return de__field_hiddenfrommentees2(inputs)
});
export { _field_hiddenfrommentees2 as "_field_hiddenFromMentees" }